// extracted by mini-css-extract-plugin
module.exports = {"baseTooltipOverride":"-event-sku-dropdown-baseTooltipOverride-2fbYNg-","options":"-event-sku-dropdown-options-2ULx6O-","option":"-event-sku-dropdown-option-YNaX50-"};